import { Translation } from 'react-i18next';
import React from 'react';
import { Modal } from '@/components';
import style from './index.module.scss';
import { openNewWindow } from 'utils';

const openJoinProPage = (hide?: () => void) => {
  openNewWindow('/settings', '_blank');
  hide && hide();
};

export const openFollowLimitModal = (errMsg: string) => {
  Modal.info({
    title: <Translation>{t => t('FollowLimitModal_FollowLimitModal.rcphtq')}</Translation>,
    onConfirmClick: openJoinProPage,
    content: hide => (
      <div className={style.container}>
        {errMsg}{' '}
        <span className={style.primaryText} onClick={() => openJoinProPage(hide)}>
          <Translation>{t => t('FollowLimitModal_FollowLimitModal.5eh9ot')}</Translation>
        </span>
      </div>
    ),
    confirmBtnText: 'Mint your Web3 ID',
  });
};
